/**
 * Builds the options object for calculateFee / calculateFeeAmountAndVersion
 * when Mobilize flat fee logic may apply.
 *
 * Both conditions must be met for the flat fee:
 * - vehicleSource (sourcePartner) is 'mobilize'
 * - dealerPartners includes 'mobilize'
 */
export const getMobilizeFeeOptions = ({
	partners,
	sourcePartner,
}: {
	partners?: string[];
	sourcePartner?: string | null;
}) => ({
	dealerPartners: (partners || []).map((p) => p.toLowerCase()),
	vehicleSource: sourcePartner?.toLowerCase() || '',
});
